import { atom } from 'recoil';
export const aInvitationLanguage = atom<string>({ key: 'aInvitationLanguage', default: '' });
